import { render } from "./RouteTarget.vue?vue&type=template&id=7dcac856"
import script from "./RouteTarget.vue?vue&type=script&lang=js"
export * from "./RouteTarget.vue?vue&type=script&lang=js"
script.render = render

export default script